/**
 * 時間前市場の開場定数。
 *
 * 受渡日前日 17:00 (= mock IntradayMarket.razor と整合) が開場時刻。
 * この定数が変わった場合は models/marketOpen.ts の判定ロジックも合わせて確認する。
 * SoT: frontend 定数 (v1)。将来 BFF から取得する場合は本ファイルを更新する。
 */

/** 時間前市場の開場時刻 (= 受渡日前日の時)。 */
export const INTRADAY_MARKET_OPEN_HOUR = 17

/** 時間前市場の開場時刻 (= 受渡日前日の分)。 */
export const INTRADAY_MARKET_OPEN_MINUTE = 0

/**
 * 時間前入札の受付開始時刻 (= 受渡日前日の時)。
 *
 * 受渡日 D のスポット約定が確定するまで JEPX 渡し契約分を含む需給ギャップが
 * 確定しないため、 D の時間前入札は D-1 12:00 (JST) から受け付ける
 * (spec AC-BIN-089c)。 開場 (17:00) より前の 12:00〜17:00 が予約送信の窓。
 */
export const INTRADAY_ACCEPTANCE_OPEN_HOUR = 12

/** 時間前入札の受付開始時刻 (= 受渡日前日の分)。 */
export const INTRADAY_ACCEPTANCE_OPEN_MINUTE = 0

/** stream 再接続 backoff の初期値 (ms)。 */
export const STREAM_BACKOFF_INITIAL_MS = 1_000

/** stream 再接続 backoff の上限 (ms)。 */
export const STREAM_BACKOFF_CAP_MS = 16_000

/** stream reconnect の backoff 乗数。 */
export const STREAM_BACKOFF_MULTIPLIER = 2

/**
 * 約定履歴ティッカーの推定エリア・売買区分を取り直す間隔 (ms、 AC-BIN-031)。
 *
 * eSLJ は推定が済んでも市場更新の通知を出さないため、 自動更新 ON の間は約定一覧を一定間隔で
 * 取り直す。 eSLJ の判定は 2 分ごとなので、 判定から 30 秒以内に画面へ出る間隔にしている。
 */
export const TICKER_ESTIMATE_REFETCH_INTERVAL_MS = 30_000
